import { render, staticRenderFns } from "./IntroShort.vue?vue&type=template&id=374e05ab&scoped=true&"
import script from "./IntroShort.vue?vue&type=script&lang=ts&"
export * from "./IntroShort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e05ab",
  null
  
)

export default component.exports